import { useEffect, useState } from 'react';

const unavailableConfig = {
  shippingMode: 'usps',
  carrierQuotesConfigured: false,
  shippingCarrier: 'USPS',
};

let cachedConfig = null;
let configRequest = null;

const loadStoreConfig = () => {
  if (cachedConfig) return Promise.resolve(cachedConfig);
  if (!configRequest) {
    configRequest = fetch('/api/config')
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.message || 'Store configuration is unavailable');
        cachedConfig = data;
        return data;
      })
      .finally(() => {
        configRequest = null;
      });
  }
  return configRequest;
};

const useStoreConfig = () => {
  const [config, setConfig] = useState(cachedConfig);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    loadStoreConfig()
      .then((data) => {
        if (mounted) setConfig(data);
      })
      .catch((requestError) => {
        if (!mounted) return;
        setConfig(unavailableConfig);
        setError(requestError.message);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return { config, error, loading: !config };
};

export default useStoreConfig;
